import { render, staticRenderFns } from "./TaskIndex.vue?vue&type=template&id=d0da676c&"
import script from "./TaskIndex.vue?vue&type=script&lang=js&"
export * from "./TaskIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports